
import vue from '../../../adapter-vue';
import { isPC } from '../../../utils/env';

const { ref } = vue;

interface Props {
  emojiConfig: Record<string, any>;
}
export default {
  props: {
    emojiConfig: {
      type: Object as () => Record<string, any>,
      default: () => ({}),
    },
  },
  emits: ['selectEmoji'],
  setup(props: Props, { emit }) {
    const emojiPickerListRef = ref();
    const selectEmoji = (reactionID: string) => {
      emit('selectEmoji', reactionID);
    };
    return {
      emojiPickerListRef,
      selectEmoji,
      props,
      isPC,
    };
  },
};
